<script lang="ts" setup>
</script>

<template>
  <ADevice>
    <template #h5>
      <MLayout>
        <slot></slot>
      </MLayout>
    </template>
    <template #pc>
      <ALayout>
        <slot></slot>
      </ALayout>
    </template>
  </ADevice>
</template>

<style lang="scss" scoped></style>
